import Vue from 'vue';
import moment from 'moment-timezone';
import EventBus from '@/eventBus';
import {
  CHAT_CHECK_FAILED_MESSAGES,
  CHAT_SEND_MESSAGE_RETRY,
} from '@/eventTypes';

// eslint-disable-next-line import/prefer-default-export
export const mutations = {
  setAlertSocket(state, payload) {
    state.alertSocket = payload;
  },
  itsReady(state, payload) {
    state.ready = payload;
  },
  setToken(state, payload) {
    localStorage.setItem('hey-token', payload);
    state.token = payload;
  },
  setUser(state, payload) {
    state.user = payload;
  },
  setActiveClient(state, clientId) {
    state.activeClientId = clientId;
  },
  setActiveClientHistory(state, { conversation }) {
    state.activeClientHistoryId = null;
    setTimeout(() => {
      state.activeClientHistoryId = conversation.id;
    }, 10);
  },
  resetActiveClients(state) {
    state.activeClientId = '';
    state.activeClientHistoryId = null;
  },
  addConversations(state, payload) {
    payload.forEach((conversation) => {
      this.commit('removeFromHistory', conversation);

      const index = state.conversations.findIndex((el) => conversation.client.id === el.client.id);

      if (index !== -1) {
        Vue.set(state.conversations, index, {
          ...state.conversations[index],
          ...conversation,
        });
      } else {
        state.conversations.push(conversation);
      }
    });
  },
  addHistoryClient(state, { clientId, history }) {
    const index = state.conversations.findIndex(({ client }) => client.id === clientId);
    if (index !== -1) {
      state.conversations[index].client.history.unshift(history);
      state.conversations[index].client.history.pop();
      Vue.set(state.conversations, index, {
        ...state.conversations[index],
      });
    }
  },
  removeFromHistory(state, { client, conversation }) {
    const idx = state.conversationsHistory.findIndex(
      (el) => el.client.id === client.id && conversation.channel.id === el.conversation.channel.id,
    );

    if (idx !== -1) {
      state.conversationsHistory.splice(idx, 1);
    }
  },
  addConversationsHistory(state, payload) {
    state.conversationsHistory = payload;
  },
  addPreviousMessages(state, { clientId, messages }) {
    const index = state.conversations.findIndex(({ client }) => client.id === clientId);

    if (index !== -1) {
      const newMessages = messages.concat(state.conversations[index].messages);

      Vue.set(state.conversations, index, {
        ...state.conversations[index],
        messages: newMessages,
      });
    }
  },
  addPreviousMessagesHistory(state, { clientId, messages }) {
    const index = state.conversationsHistory.findIndex(
      ({ conversation }) => conversation.id === clientId,
    );

    if (index !== -1) {
      const newMessages = messages.concat(state.conversationsHistory[index].messages);

      Vue.set(state.conversationsHistory, index, {
        ...state.conversationsHistory[index],
        messages: newMessages,
      });
    }
  },
  async addClientBlocked(state, props) {
    const index = state.conversations.findIndex(({ client }) => client.id === props.client);

    if (index !== -1) {
      const blocked = {
        campaign: props.campaign,
        channel: props.channel,
        user: props.idAgent,
      };

      const conversationBlocked = state.conversations[index];
      if (conversationBlocked.client?.blocked?.length > 0) {
        conversationBlocked.client.blocked.push(blocked);
      } else {
        conversationBlocked.client.blocked = [blocked];
      }

      Vue.set(state.conversations, index, conversationBlocked);
    }
  },
  addMessageToConversation(state, { clientId, message, fromHistory = false }) {
    if (fromHistory) {
      this.commit('moveConversationFromHistory', message);
      this.commit('clearConversationStates', clientId);
      this.commit('setMessageFromHistory', true);
    }

    const indexConversation = state.conversations.findIndex(({ client }) => client.id === clientId);

    if (indexConversation !== -1) {
      if (!message.id) {
        if (message.errorCode && message.errorCode === 2404) {
          const indexMessage = state.conversations[indexConversation].messages.findIndex(
            ({ tempId }) => !!tempId && tempId === message.tempId,
          );

          state.conversations[indexConversation].messages.splice(indexMessage, 1);
        } else {
          state.conversations[indexConversation].messages.push(message);
        }
      } else {
        const indexMessage = state.conversations[indexConversation].messages.findIndex(
          ({ id, tempId }) => id === message.id || (!!tempId && tempId === message.tempId),
        );

        if (indexMessage !== -1) {
          Vue.set(state.conversations[indexConversation].messages, indexMessage, message);
        } else {
          const msgTotal = state.conversations[indexConversation].messages.length;
          const conversationMessages = state.conversations[indexConversation].messages;
          const newestDate = conversationMessages[msgTotal - 1].createdAt ?? null;

          if (moment(message.createdAt).isAfter(newestDate)) {
            state.conversations[indexConversation].messages.push(message);

            if (message.typeUser === 'Client') {
              const newLastMessage = moment(newestDate).local().format();
              Vue.set(state.conversations[indexConversation].conversation, 'lastMessageAt', newLastMessage);
            }
          } else {
            const oldestDate = conversationMessages[0].createdAt ?? null;

            if (moment(message.createdAt).isBefore(oldestDate)) {
              state.conversations[indexConversation].messages.unshift(message);
            } else if (moment(message.createdAt).isSame(newestDate)) {
              state.conversations[indexConversation].messages.push(message);
            } else {
              const newIndex = conversationMessages.findIndex(
                ({ createdAt }) => moment(message.createdAt).isBefore(createdAt),
              );

              state.conversations[indexConversation].messages.splice(newIndex, 0, message);
            }
          }
        }
      }
    } else {
      console.warn(`conversation not found ${clientId}`);
    }
  },
  moveConversationFromHistory(state, { clientId, channelId }) {
    const idx = state.conversationsHistory.findIndex(
      ({ client, conversation }) => client.id === clientId && conversation.channel.id === channelId,
    );

    if (idx !== -1) {
      const conversationData = state.conversationsHistory[idx];
      state.conversationsHistory.splice(idx, 1);
      state.conversations.push(conversationData);
    }
  },
  updateConversationFirstLoadState(state, { clientId, firstLoad }) {
    if (state.conversationStates[clientId]) {
      state.conversationStates[clientId] = { ...state.conversationStates[clientId], firstLoad };
    } else {
      Vue.set(state.conversationStates, clientId, {
        firstLoad,
      });
    }
  },
  updateConversationLoadingState(state, { clientId, loading }) {
    if (state.conversationStates[clientId]) {
      state.conversationStates[clientId] = { ...state.conversationStates[clientId], loading };
    } else {
      Vue.set(state.conversationStates, clientId, {
        loading,
      });
    }
  },
  updateConversationTopReachedState(state, { clientId, topReached }) {
    if (state.conversationStates[clientId]) {
      state.conversationStates[clientId] = { ...state.conversationStates[clientId], topReached };
    } else {
      Vue.set(state.conversationStates, clientId, {
        topReached,
      });
    }
  },
  updateConversationCurrentInput(state, { clientId, currentInput }) {
    if (state.conversationStates[clientId]) {
      state.conversationStates[clientId] = { ...state.conversationStates[clientId], currentInput };
    } else {
      Vue.set(state.conversationStates, clientId, {
        currentInput,
      });
    }
  },
  setClientHistory(state, { clientId, history }) {
    const index = state.conversations.findIndex(({ client }) => client.id === clientId);

    if (index !== -1) {
      Vue.set(state.conversations[index].client, 'history', history);
    }
  },
  clearConversationStates(state, clientId) {
    Vue.delete(state.conversationStates, clientId);
  },
  setClientHistoryClosed(state, { clientId, history }) {
    const index = state.conversationsHistory.findIndex(({ client }) => client.id === clientId);

    if (index !== -1) {
      Vue.set(state.conversationsHistory[index].client, 'history', history);
    }
  },
  setConfiguration(state, payload) {
    state.configuration = payload;
  },
  removeDataBankConfiguration(state, { link, type }) {
    const index = state.configuration.dataBank.findIndex(({ [type]: data }) => data.url === link);
    if (index !== -1) {
      state.configuration.dataBank.splice(index, 1);
    }
  },
  setLabels(state, { clientId, labels }) {
    const index = state.conversations.findIndex(({ client }) => client.id === clientId);

    if (index !== -1) {
      Vue.set(state.conversations[index].client, 'labels', labels);
    } else {
      const i = state.conversationsHistory.findIndex(({ client }) => client.id === clientId);
      Vue.set(state.conversationsHistory[i].client, 'labels', labels);
    }
  },
  setNameClient(state, { clientId, name, fullName }) {
    const index = state.conversations.findIndex(({ client }) => client.id === clientId);
    if (index !== -1) {
      Vue.set(state.conversations[index].client, 'name', name);
      Vue.set(state.conversations[index].client, 'fullName', fullName);
    }
  },
  removeConversation(state, { clientId, channelId, action }) {
    const index = state.conversations.findIndex(
      ({ client, conversation }) => client.id === clientId && conversation.channel.id === channelId,
    );

    if (index !== -1) {
      if (action.toLowerCase() === 'closed') {
        const conversationData = state.conversations[index];
        state.conversationsHistory.push(conversationData);
      }

      this.commit('clearConversationStates', clientId);
      state.conversations.splice(index, 1);

      if (state.activeClientId === clientId) {
        state.activeClientId = '';
      }
    }
  },
  toggleAppVisibility(state, value) {
    state.appIsVisible = value;
  },
  toggleNotificationSound(state, value) {
    // TODO modify this in configuration section
    state.playNotificationSound = value;
  },
  setFavoriteUser(state, { agentID, campaignID }) {
    const activeConvo = state.conversations.find(
      ({ client }) => client.id === state.activeClientId,
    );

    const { favorites } = activeConvo.client;

    const favoriteUser = favorites.find((fave) => fave.campaign === campaignID
      && fave.user === agentID);

    if (favoriteUser) {
      const i = favorites.findIndex((fave) => fave.campaign === favoriteUser.campaign
        && fave.user === favoriteUser.user);

      favorites.splice(i, 1);
    } else {
      favorites.push({ campaign: campaignID, user: agentID });
    }
  },
  addUserMultimedia(state, {
    data, type, id, total,
  }) {
    if (state.userMultimedia[id]) {
      if (state.userMultimedia[id][type]) {
        let { multimedia } = state.userMultimedia[id][type];
        let finalTotal = state.userMultimedia[id][type].total;

        const notNew = multimedia.some(({ id: mid }) => mid === data[0].id);

        if (!notNew) {
          if (total) {
            multimedia = multimedia.concat(data);
          } else {
            multimedia = data.concat(multimedia);
            finalTotal += 1;
          }

          Vue.set(state.userMultimedia[id], type, { multimedia, total: finalTotal });
        }
      } else {
        const addElement = {
          ...state.userMultimedia[id],
          [type]: {
            multimedia: data,
            total,
          },
        };
        Vue.set(state.userMultimedia, id, addElement);
      }
    } else {
      const newData = {
        clientId: id,
        [type]: {
          multimedia: data,
          total,
        },
      };

      Vue.set(state.userMultimedia, id, newData);
    }
  },
  setLanguage(state, lang) {
    state.language = lang;
  },
  toggleAppTheme(state, value) {
    state.theme = value;
    localStorage.setItem('appTheme', value);
  },
  setTheme(state) {
    if (localStorage.getItem('appTheme') === 'dark') {
      state.theme = 'dark';
    } else {
      state.theme = 'light';
    }
  },
  addFailedMessage(state, message) {
    const msg = state.failedMessages.find((el) => el.id === message.tempId);

    if (msg) {
      if (msg.retries < 3) {
        msg.retries += 1;
      } else {
        msg.status = 'failed';
      }
    } else {
      const data = {
        id: message.tempId,
        status: 'pending',
        retries: 0,
        message,
        job: null,
      };

      state.failedMessages.push(data);
    }

    EventBus.$emit(CHAT_CHECK_FAILED_MESSAGES);
  },
  startFailedMessageJob(state, id) {
    const msg = state.failedMessages.find((el) => el.id === id);

    if (msg) {
      const delay = (msg.retries * 10 + 10) * 1000;

      msg.job = setTimeout(() => {
        EventBus.$emit(CHAT_SEND_MESSAGE_RETRY, msg.message);
      }, delay);
    }
  },
  deleteFailedMessageJob(state, id) {
    const idx = state.failedMessages.findIndex((el) => el.id === id);

    if (idx !== -1) {
      state.failedMessages.splice(idx, 1);
    }
  },
  restartFailedMessageJob(state, id) {
    const msg = state.failedMessages.find((el) => el.id === id);

    if (msg) {
      msg.retries = 0;
      msg.status = 'pending';

      EventBus.$emit(CHAT_CHECK_FAILED_MESSAGES);
    }
  },
  setCurrentCampaign(state, campaignId) {
    state.currentCampaign = campaignId;
  },
  setMessageFromHistory(state, value) {
    state.messageFromHistory = value;
  },
  setCampaingDataBank(state, { key, ...data }) {
    let remainder = [];
    if (key === 'templates') {
      const campaingId = data.templates[0].campaign.id;
      const { templates } = state.configuration;
      remainder = templates.filter(({ campaign }) => campaign.id !== campaingId);
    } else {
      const campaingId = data.dataBank[0].campaign;
      const { dataBank } = state.configuration;
      remainder = dataBank.filter(({ campaign }) => campaign !== campaingId);
    }

    Vue.set(state.configuration, key, remainder.concat(data[key]));
  },
  setCampaingConfig(state, { configuration }) {
    const { configuration: { campaigns, channels } } = state.configuration;
    const idCampaign = configuration.campaigns[0].id;
    const idChannel = configuration.channels[0].channelId;

    const campaign = campaigns.filter(({ id }) => id !== idCampaign);
    const channel = channels.filter(({ channelId }) => channelId !== idChannel);
    const newConfig = {
      channels: channel.concat(configuration.channels),
      campaigns: campaign.concat(configuration.campaigns),
    };
    Vue.set(state.configuration, 'configuration', newConfig);
  },
};
